import { STOModel } from "../../models/base/sto-model";
import { UserEmployeeActivityHistoryDTO } from "../../models/user-employee-activity-history";
import { BaseApiService } from "../base";

export class EmployeeActivityApiService extends BaseApiService<UserEmployeeActivityHistoryDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/EmployeeActivity",
      loadItemsPath: "/GetEmployeeActivity",
    });
  }
}
